/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { List, Checkbox, Button, Segment, Divider, Form, Dimmer, Loader } from "semantic-ui-react";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

const UtilsInstance = new Utils();

var formInput = "";

export class EditGSD extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      originalFilenames: [],
      filenames: [],
      checkedList: [],
      isGSDDimmerActive: false,
      numOfSuccessfullFilesRemoved: 0
    };

    this.checkAllCheckbox = React.createRef();
  }

  showGSDDimmer = () => this.setState({ isGSDDimmerActive: true })
  hideGSDDimmer = () => this.setState({ isGSDDimmerActive: false })

  retrieveData = () => {
    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "/gsdFiles", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        filenames: data,
        originalFilenames: data
      }, () => {
        this.setState({ checkedList: [] }, () => {
          this.buildCheckedList();
          document.getElementById("input-form").value = "";
          this.checkAllCheckbox.current.setState({ checked: false });
        });
      }));
  }

  buildCheckedList = () => {
    const checkedListCopy = [];

    for (let i = 0; i < this.state.filenames.length; i++) {
      checkedListCopy[this.state.filenames[i]] = false;
    }

    this.setState({ checkedList: checkedListCopy });
  }

  toggleCheckbox = (gsdFilename) => {
    const checkedListCopy = this.state.checkedList;

    checkedListCopy[gsdFilename] = !checkedListCopy[gsdFilename];

    this.setState({ checkedList: checkedListCopy });
  }

  toggleAllCheckboxes = (event, data) => {
    const checkedListCopy = [];

    for (let i = 0; i < this.state.filenames.length; i++) {
      checkedListCopy[this.state.filenames[i]] = data.checked;
    }

    this.setState({ checkedList: checkedListCopy });
  }

  handleDeleteGsdFiles = async () => {
    let gsdFilesToDelete = {
      gsdFiles: []
    };
    let notRemovedFilenames = [];

    // Add to the array the names of all files that will be removed
    for (let i = 0; i < this.state.filenames.length; i++) {
      if (this.state.checkedList[this.state.filenames[i]]) {
        gsdFilesToDelete.gsdFiles.push(this.state.filenames[i]);
      }
    }

    if (gsdFilesToDelete.gsdFiles.length === 0) {
      alert(Strings.SELECT_AT_LEAST_ONE_FILE_TO_DELETE);
    }
    else {
      document.getElementById("total-num-of-files").innerText = gsdFilesToDelete.gsdFiles.length;

      this.showGSDDimmer();

      for (let i = 0; i < gsdFilesToDelete.gsdFiles.length; i++) {
        let data = { gsdFiles: [gsdFilesToDelete.gsdFiles[i]] };

        await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "/removeGsdFiles_POST", {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          body: JSON.stringify(data),
          mode: "cors"
        })
          .then(UtilsInstance.checkStatus)
          .then(() => {
            // If the file was removed successfully, increment the number of removed files 
            // and show it on the loading dimmer
            this.setState({
              numOfSuccessfullFilesRemoved: this.state.numOfSuccessfullFilesRemoved + 1
            }, () => {
              document.getElementById("num-of-successful-files-removed").innerText = this.state.numOfSuccessfullFilesRemoved;
            });
          })
          .catch(() => {
            // If there was a problem while sending the file, add the file name to an array
            // so it can be shown to the user later
            notRemovedFilenames.push(gsdFilesToDelete.gsdFiles[i]);
          });
      }

      // If all the files have been sent, alert the user
      if (notRemovedFilenames.length === 0) {
        setTimeout(() => {
          alert(Strings.REMOVE_GSD_SUCCESS);
          this.hideGSDDimmer();
          this.setState({ numOfSuccessfullFilesRemoved: 0 }, () => {
            document.getElementById("num-of-successful-files-removed").innerText = 0;
          });
          this.retrieveData();
        }, 500);
      }
      // If at least one file was not removed, alert the user, and show a list of all of 
      // the files that were not removed
      else {
        let notRemovedFilenamesList = "";

        for (let i = 0; i < notRemovedFilenames.length; i++) {
          notRemovedFilenamesList = notRemovedFilenamesList.concat("\n• " + notRemovedFilenames[i]);
        }

        alert(Strings.THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED + notRemovedFilenamesList);
        this.hideGSDDimmer();
        this.setState({ numOfSuccessfullFilesRemoved: 0 }, () => {
          document.getElementById("num-of-successful-files-removed").innerText = 0;
        });
        this.retrieveData();
      }
    }
  }

  handleFormChange = (event, data) => {
    formInput = data.value;
  };

  handleSearch = () => {
    let searchFilenames = [];

    for (let i = 0; i < this.state.originalFilenames.length; i++) {

      let upperOriginalFilename = this.state.originalFilenames[i].toUpperCase();
      let upperFormInput = formInput.toUpperCase();

      if (upperOriginalFilename.indexOf(upperFormInput) !== -1) {
        searchFilenames.push(this.state.originalFilenames[i]);
      }
    }

    // Reset the list if the user searches with an empty string
    if (formInput === "") {
      this.setState({ filenames: this.state.originalFilenames });
    }
    else {
      this.setState({ filenames: searchFilenames });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
  }

  render() {
    const isGSDDimmerActive = this.state.isGSDDimmerActive;

    const gsdList = this.state.filenames.map(filename => (
      <List.Item key={filename}>
        <Checkbox
          label={filename}
          checked={this.state.checkedList[filename]}
          onChange={() => { this.toggleCheckbox(filename); }}
        />
      </List.Item>
    ));

    return (
      <Segment style={centerStyle}>

        <Divider horizontal style={dividerStyle}>{Strings.REMOVE_GSD_FILES}</Divider>

        <Form style={searchStyle} onSubmit={this.handleSearch} >
          <Form.Input
            placeholder={Strings.FILTER_GSD_FILES}
            id="input-form"
            icon="search"
            name="formInput"
            onChange={this.handleFormChange} />
        </Form>

        <Checkbox
          ref={this.checkAllCheckbox}
          label={Strings.SELECT_ALL}
          onChange={this.toggleAllCheckboxes} />

        <Segment style={listStyle}>
          <List divided style={listScrollStyle}>
            {gsdList}
          </List>
        </Segment>

        <Button
          style={buttonStyle}
          color="teal"
          content={Strings.REMOVE_SELECTED}
          onClick={this.handleDeleteGsdFiles} />

        <Dimmer active={isGSDDimmerActive} >
          <Loader>
            <p>{Strings.REMOVING_GSD_FILES}</p>
            <p><span id="num-of-successful-files-removed">0</span> / <span id="total-num-of-files"></span></p>
          </Loader>
        </Dimmer>
      </Segment>
    );
  }
}

const centerStyle = {
  textAlign: "center",
  marginLeft: "auto",
  marginRight: "auto",
  width: "50%"
};

const searchStyle = {
  margin: "0 auto"
};

const listStyle = {
  margin: "0 auto"
};

const buttonStyle = {
  width: "50%",
  marginTop: "16px"
};

const listScrollStyle = {
  overflow: "auto",
  maxHeight: "430px"
};

const dividerStyle = {
  marginTop: "16px",
  marginBottom: "32px",
  marginLeft: "auto",
  marginRight: "auto"
};

export default EditGSD;